module.exports = __webpack_public_path__ + "img/no45.7fb53e77.jpg";